export default "__VITE_ASSET__D0K1ulSK__"